import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import sweetalert from "sweetalert";
import ApiEnter from "@/api/ApiEnter";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import PageHeader from "@/components/UI/PageHeader.vue";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import CKEditorConfig from "@/data/CKeditor/config";
import dayjs from "dayjs";
import ApiLandingPages from "@/api/ApiLandingPages";
import ApiOffer from "@/api/ApiOffer";
import ApiAdmin from "@/api/ApiAdmin";
import UtilGeneral from "@/util/Common/UtilGeneral";
import ApiSettings from "@/api/ApiSettings";
let EditStaticPage = class EditStaticPage extends Vue {
    constructor() {
        super(...arguments);
        this.Breadcrumbs = [
            {
                to: "/",
                text: "Home"
            },
            {
                to: "/admin/blog",
                text: "CMS",
                disabled: true
            },
            {
                text: "Edit landing page",
                disabled: true
            }
        ];
        this.HasLoading = false;
        this.editor = ClassicEditor;
        this.editorConfig = CKEditorConfig.editorStaticPagesConfig(ApiEnter.CurrentSessionUUID);
        this.listEmailTemplates = [];
        this.ShopOffers = [];
        this.SelectedOffer = null;
        this.SelectedOffersList = [];
        this.newData = {
            uuid: "",
            title: "",
            url: "",
            header_banner_primary_text: "",
            header_banner_secondary_text: "",
            header_banner_discount_code: "",
            header_banner_img_url: "",
            header_banner_img_name: "",
            header_banner_img_mobile_url: "",
            header_banner_img_mobile_name: "",
            middle_banner_primary_text: "",
            middle_banner_secondary_text: "",
            middle_banner_img_url: "",
            middle_banner_img_name: "",
            middle_banner_img_mobile_url: "",
            middle_banner_img_mobile_name: "",
            offer_list: "",
            text_section_primary_header: "",
            text_section_secondary_header: "",
            text_section_content: "",
            second_text_section_primary_header: "",
            second_text_section_secondary_header: "",
            second_text_section_content: "",
            no_index: 0,
            form_active: false,
            form_title: "",
            form_text_label_1: "",
            form_template_email_uuid: "",
            created_at: "",
            updated_at: ""
        };
    }
    Translit(str) {
        let ru = "А-а-Б-б-В-в-Ґ-ґ-Г-г-Д-д-Е-е-Ё-ё-Є-є-Ж-ж-З-з-И-и-І-і-Ї-ї-Й-й-К-к-Л-л-М-м-Н-н-О-о-П-п-Р-р-С-с-Т-т-У-у-Ф-ф-Х-х-Ц-ц-Ч-ч-Ш-ш-Щ-щ-Ъ-ъ-Ы-ы-Ь-ь-Э-э-Ю-ю-Я-я".split("-");
        let en = "A-a-B-b-V-v-G-g-G-g-D-d-E-e-E-e-E-e-ZH-zh-Z-z-I-i-I-i-I-i-J-j-K-k-L-l-M-m-N-n-O-o-P-p-R-r-S-s-T-t-U-u-F-f-H-h-TS-ts-CH-ch-SH-sh-SCH-sch-'-'-Y-y-'-'-E-e-YU-yu-YA-ya".split("-");
        let res = "";
        for (let i = 0, l = str.length; i < l; i++) {
            let s = str.charAt(i), n = ru.indexOf(s);
            if (n >= 0) {
                res += en[n];
            }
            else {
                res += s;
            }
        }
        return res;
    }
    GenerateSeoUrl() {
        let url = this.Translit(this.newData.title.replace(/[\s]+/gi, "-"));
        this.newData.url = url.replace(/[^0-9a-z_-]+/gi, "").toLowerCase();
    }
    ValidateSeoUrl() {
        this.newData.url = this.Translit(this.newData.url.replace(/[. ,$@!^()'*]+/g, "-").toLowerCase());
    }
    CopyLink(link) {
        UtilGeneral.CopyLink(link);
    }
    async DownloadPhotoSlide(filename) {
        await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, filename).then(response => {
            let a = document.createElement("a");
            let file = new Blob([response]);
            a.href = URL.createObjectURL(file);
            a.download = filename.split("/")[8];
            a.click();
        });
    }
    async OnClickSubmit() {
        this.HasLoading = true;
        if (ApiEnter.CurrentSessionUUID != undefined) {
            const data = this.newData;
            data.offer_list = this.SelectedOffersList.join(",");
            await Promise.all([
                this.UploadHeaderBannerImg(data),
                this.UploadMiddleBannerImg(data),
                this.UploadHeaderBannerMobileImg(data),
                this.UploadMiddleBannerMobileImg(data)
            ]);
            const response = await ApiLandingPages.UpdateLandingPage(ApiEnter.CurrentSessionUUID, data);
            if (response) {
                sweetalert({
                    title: this.$t("general.success"),
                    text: this.$t("general.success_created"),
                    icon: "success",
                }).then(() => {
                    this.$router.push(`/cms/landing-pages/list`);
                });
            }
            else {
                sweetalert({
                    title: "Error",
                    text: "Error with create landing page",
                    icon: "error",
                });
            }
        }
        this.HasLoading = false;
    }
    async UploadHeaderBannerImg(data) {
        if (this.newData.header_banner_img_url) {
            data.header_banner_img_url = await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newData.header_banner_img_url, this.newData.header_banner_img_name);
        }
    }
    async UploadMiddleBannerImg(data) {
        if (this.newData.middle_banner_img_url) {
            data.middle_banner_img_url = await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newData.middle_banner_img_url, this.newData.middle_banner_img_name);
        }
    }
    async UploadHeaderBannerMobileImg(data) {
        if (this.newData.header_banner_img_mobile_url) {
            data.header_banner_img_mobile_url = await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newData.header_banner_img_mobile_url, this.newData.header_banner_img_mobile_name);
        }
    }
    async UploadMiddleBannerMobileImg(data) {
        if (this.newData.middle_banner_img_mobile_url) {
            data.middle_banner_img_mobile_url = await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newData.middle_banner_img_mobile_url, this.newData.middle_banner_img_mobile_name);
        }
    }
    async DownloadHeaderBannerImg(response) {
        if (response.header_banner_img_url) {
            const temp = await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, response.header_banner_img_url);
            const fileData = new File([
                new Blob([temp.data])
            ], response.header_banner_img_url.split("/")[8]);
            this.newData.header_banner_img_url = fileData;
            this.newData.header_banner_img_name = response.header_banner_img_url;
        }
    }
    async DownloadMiddleBannerImg(response) {
        if (response.middle_banner_img_url) {
            const temp = await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, response.middle_banner_img_url);
            const fileData = new File([
                new Blob([temp.data])
            ], response.middle_banner_img_url.split("/")[8]);
            this.newData.middle_banner_img_url = fileData;
            this.newData.middle_banner_img_name = response.middle_banner_img_url;
        }
    }
    async DownloadHeaderBannerMobileImg(response) {
        if (response.header_banner_img_mobile_url) {
            const temp = await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, response.header_banner_img_mobile_url);
            const fileData = new File([
                new Blob([temp.data])
            ], response.header_banner_img_mobile_url.split("/")[8]);
            this.newData.header_banner_img_mobile_url = fileData;
            this.newData.header_banner_img_mobile_name = response.header_banner_img_mobile_url;
        }
    }
    async DownloadMiddleBannerMobileImg(response) {
        if (response.middle_banner_img_mobile_url) {
            const temp = await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, response.middle_banner_img_mobile_url);
            const fileData = new File([
                new Blob([temp.data])
            ], response.middle_banner_img_url.split("/")[8]);
            this.newData.middle_banner_img_mobile_url = fileData;
            this.newData.middle_banner_img_mobile_name = response.middle_banner_img_mobile_url;
        }
    }
    async GetLandingPage() {
        const response = await ApiLandingPages.GetLandingPageByUUID(ApiEnter.CurrentSessionUUID, this.CurrentStaticPageUUID);
        if (typeof response != "boolean") {
            this.newData = { ...response };
            this.SelectedOffersList = response.offer_list.split(",");
            await Promise.all([
                this.DownloadHeaderBannerImg(response),
                this.DownloadMiddleBannerImg(response),
                this.DownloadHeaderBannerMobileImg(response),
                this.DownloadMiddleBannerMobileImg(response),
            ]);
        }
        else {
            sweetalert({
                title: "Error with get static page",
                icon: "error",
            });
        }
    }
    formatDate(item) {
        if (item) {
            return dayjs.tz(item, "Europe/Rome").format("DD.MM.YYYY HH:mm:ss");
        }
        return "";
    }
    get AvailableShopOffers() {
        const usedOptions = this.SelectedOffersList.map(String);
        if (!this.ShopOffers) {
            return [];
        }
        return this.ShopOffers.filter(el => el.external_id).filter(el => !usedOptions.includes(String(el.external_id)));
    }
    async GetShopOffers() {
        try {
            const offers = await ApiOffer.GetOffers(ApiEnter.CurrentSessionUUID);
            if (typeof offers === "boolean") {
                return;
            }
            this.ShopOffers = offers || [];
        }
        catch (e) {
            console.error(e);
        }
    }
    CanSubmit() {
        if (this.newData.title === '') {
            return false;
        }
        if (this.newData.header_banner_primary_text === '') {
            return false;
        }
        if (this.newData.header_banner_secondary_text === '') {
            return false;
        }
        if (this.newData.header_banner_discount_code === '') {
            return false;
        }
        if (this.newData.header_banner_img_url === '') {
            return false;
        }
        if (this.newData.middle_banner_primary_text === '') {
            return false;
        }
        if (this.newData.middle_banner_secondary_text === '') {
            return false;
        }
        if (this.newData.middle_banner_img_url === '') {
            return false;
        }
        if (this.newData.text_section_primary_header === '') {
            return false;
        }
        if (this.newData.text_section_secondary_header === '') {
            return false;
        }
        if (this.newData.text_section_content === '') {
            return false;
        }
        if (this.newData.second_text_section_primary_header === '') {
            return false;
        }
        if (this.newData.second_text_section_secondary_header === '') {
            return false;
        }
        if (this.newData.second_text_section_content === '') {
            return false;
        }
        return true;
    }
    async GetEmailNotifications() {
        try {
            let getListEmailTemplates = await ApiSettings.GetEmailNotifications(ApiEnter.CurrentSessionUUID);
            if (getListEmailTemplates?.length) {
                getListEmailTemplates = getListEmailTemplates.map(item => ({
                    text: item.template_name,
                    value: item.uuid
                }));
            }
            this.listEmailTemplates = getListEmailTemplates;
        }
        catch (e) {
            console.error(e);
        }
    }
    created() {
        this.CurrentStaticPageUUID = this.$route.params.uuid;
        this.GetShopOffers();
        this.GetLandingPage();
        this.GetEmailNotifications();
    }
};
EditStaticPage = __decorate([
    Component({
        components: { PageHeader, StandartTemplate, CKEditor },
    })
], EditStaticPage);
export default EditStaticPage;
